import { combineReducers } from "redux";
import { reducer as accreditationForm } from "./accreditationForm";

export default combineReducers({
  accreditationForm,
});
